import { useMutation } from '@tanstack/react-query';
import { ConnectedProvidersService } from '@/api/user-portal-service';

export function useDiagnoseMcpServerMutation() {
  return useMutation({
    mutationFn: (serverUrl: string) =>
      ConnectedProvidersService.diagnoseMcpServer({ server_url: serverUrl }),
  });
}
